class UnitOptions {
  static getOptions() {
    return [
      {
        'key': 'phase',
        'name': 'Phase',
      },
      {
        'key': 'sq_feet',
        'name': 'SQ Feet',
      },
      {
        'key': 'unit_type',
        'name': 'Unit Type',
      },
      {
        'key': 'designation',
        'name': 'Unit Designation',
      },
      {
        'key': 'resident_name',
        'name': 'Resident Name',
      },
      {
        'key': 'roommate_1',
        'name': 'Roommate 1',
      },
      {
        'key': 'roommate_2',
        'name': 'Roommate 2',
      },
      {
        'key': 'roommate_3',
        'name': 'Roommate 3',
      },
      {
        'key': 'roommate_4',
        'name': 'Roommate 4',
      },
      {
        'key': 'move_in_date',
        'name': 'Move In Date',
      },
      {
        'key': 'move_out_date',
        'name': 'Move Out Date',
      },
      {
        'key': 'lease_start_date',
        'name': 'Lease Start Date',
      },
      {
        'key': 'lease_end_date',
        'name': 'Lease End Date',
      },
      {
        'key': 'lease_status',
        'name': 'Unit Lease Status',
      },
      {
        'key': 'on_notice',
        'name': 'On Notice',
      },
      {
        'key': 'lease_term',
        'name': 'Lease Term',
      },
      {
        'key': 'lease_type',
        'name': 'Lease Type',
      },
      {
        'key': 'required_deposit',
        'name': 'Required Deposit',
      },
      {
        'key': 'garage_deposit',
        'name': 'Garage Deposit',
      },
      {
        'key': 'key_deposit',
        'name': 'Key Deposit',
      },
      {
        'key': 'misc_deposit',
        'name': 'Misc Deposit',
      },
      {
        'key': 'pet_deposit',
        'name': 'Pet Deposit',
      },
      {
        'key': 'security_deposit',
        'name': 'Security Deposit',
      },
      {
        'key': 'storage_deposit',
        'name': 'Storage Deposit',
      },
      {
        'key': 'deposit_on_hand',
        'name': 'Deposit On Hand',
      },
      {
        'key': 'balance',
        'name': 'Balance',
      },
      {
        'key': 'lease_rent',
        'name': 'Lease Rent',
      },
      {
        'key': 'market_rent',
        'name': 'Market Rent',
      },
      {
        'key': 'rent',
        'name': 'Rent',
      },
      {
        'key': 'insurance_provider',
        'name': 'Insurance Provider',
      },
      {
        'key': 'renters_insurance',
        'name': 'Renters Insurance',
      },
      {
        'key': 'rent_concession',
        'name': 'Rent Concession',
      },
      {
        'key': 'other_rent_discount',
        'name': 'Other Rent Discount',
      },
      {
        'key': 'pet_rent',
        'name': 'Pet Rent',
      },
      {
        'key': 'pets',
        'name': 'Pets',
      },
      {
        'key': 'preferred_employer_discount',
        'name': 'Preferred Employer Discount',
      },
      {
        'key': 'fee_6_month',
        'name': '6 Month Fee',
      },
      {
        'key': 'admin_fee',
        'name': 'Admin Fee',
      },
      {
        'key': 'boat_slip_fee',
        'name': 'Boat Slip Fee',
      },
      {
        'key': 'cable_fee',
        'name': 'Cable Fee',
      },
      {
        'key': 'carport_fee',
        'name': 'Carport Fee',
      },
      {
        'key': 'corporate_rent',
        'name': 'Corporate Rent',
      },
      {
        'key': 'double_occupancy',
        'name': 'Double Occupancy',
      },
      {
        'key': 'electric_fee',
        'name': 'Electric Fee',
      },
      {
        'key': 'furniture_fee',
        'name': 'Furniture Fee',
      },
      {
        'key': 'garage_fee',
        'name': 'Garage Fee',
      },
      {
        'key': 'gas_fee',
        'name': 'Gas Fee',
      },
      {
        'key': 'guest_suite_fee',
        'name': 'Guest Suite Fee',
      },
      {
        'key': 'hud_fee',
        'name': 'HUD Fee',
      },
      {
        'key': 'internet_fee',
        'name': 'Internet Fee',
      },
      {
        'key': 'lease_break_fee',
        'name': 'Lease Break Fee',
      },
      {
        'key': 'lock_key',
        'name': 'Lock Key',
      },
      {
        'key': 'misc_fee',
        'name': 'Misc Fee',
      },
      {
        'key': 'month_to_month_fee',
        'name': 'Month-to-Month Fee',
      },
      {
        'key': 'parking_fee',
        'name': 'Parking Fee',
      },
      {
        'key': 'pest_fee',
        'name': 'Pest Fee',
      },
      {
        'key': 'recycling_fee',
        'name': 'Recycling Fee',
      },
      {
        'key': 'rubs_fee',
        'name': 'RUBS Fee',
      },
      {
        'key': 'scep_fee',
        'name': 'SCEP Fee',
      },
      {
        'key': 'short_term_fee',
        'name': 'Short Term Fee',
      },
      {
        'key': 'sewer_fee',
        'name': 'Sewer Fee',
      },
      {
        'key': 'storage_fee',
        'name': 'Storage Fee',
      },
      {
        'key': 'telecom_fee',
        'name': 'Telecom Fee',
      },
      {
        'key': 'transfer_fee',
        'name': 'Transfer Fee',
      },
      {
        'key': 'trash_fee',
        'name': 'Trash Fee',
      },
      {
        'key': 'utility_fee',
        'name': 'Utility Fee',
      },
      {
        'key': 'valet_waste_fee',
        'name': 'Valet Waste Fee',
      },
      {
        'key': 'washer_dryer_fee',
        'name': 'Washer/Dryer Fee',
      },
      {
        'key': 'water_fee',
        'name': 'Water Fee',
      },
      {
        'key': 'total_amenity_fee',
        'name': 'Total Amenity Fee',
      },
      {
        'key': 'admin_concession',
        'name': 'Admin Concession',
      },
      {
        'key': 'cable_concession',
        'name': 'Cable Concession',
      },
      {
        'key': 'electric_concession',
        'name': 'Electric Concession',
      },
      {
        'key': 'employee_discount',
        'name': 'Employee discount',
      },
      {
        'key': 'furniture_concession',
        'name': 'Furniture Concession',
      },
      {
        'key': 'garage_concession',
        'name': 'Garage Concession',
      },
      {
        'key': 'gift_card_concession',
        'name': 'Gift Card Concession',
      },
      {
        'key': 'guest_suite_concession',
        'name': 'Guest Suite Concession',
      },
      {
        'key': 'housing_concession',
        'name': 'Housing Concession',
      },
      {
        'key': 'gift_card',
        'name': 'Gift Card',
      },
      {
        'key': 'internet_concession',
        'name': 'Internet Concession',
      },
      {
        'key': 'misc_concession',
        'name': 'Misc Concession',
      },
      {
        'key': 'office_model_concession',
        'name': 'Office Model Concession',
      },
      {
        'key': 'parking_concession',
        'name': 'Parking Concession',
      },
      {
        'key': 'pest_concession',
        'name': 'Pest Concession',
      },
      {
        'key': 'pet_concession',
        'name': 'Pet Concession',
      },
      {
        'key': 'preferred_employer',
        'name': 'Preferred Employer',
      },
      {
        'key': 'referral_concession',
        'name': 'Referral Concession',
      },
      {
        'key': 'renewal_concession',
        'name': 'Renewal Concession',
      },
      {
        'key': 'storage_concession',
        'name': 'Storage Concession',
      },
      {
        'key': 'trash_concession',
        'name': 'Trash Concession',
      },
      {
        'key': 'washer_dryer_concession',
        'name': 'Washer/Dryer Concession',
      },
      {
        'key': 'water_concession',
        'name': 'Water Concession',
      },
      {
        'key': 'udf1_name',
        'name': 'UDF1 Name',
      },
      {
        'key': 'udf1_value',
        'name': 'UDF1 Value',
      },
      {
        'key': 'udf2_name',
        'name': 'UDF2 Name',
      },
      {
        'key': 'udf2_value',
        'name': 'UDF2 Value',
      },
      {
        'key': 'total_billing',
        'name': 'Total Billing',
      },
      {
        'key': 'parcel_locker',
        'name': 'Parcel Locker',
      },
      {
        'key': 'pet_fee',
        'name': 'Pet Fee',
      },
      {
        'key': 'udf3_name',
        'name': 'UDF3 Name',
      },
      {
        'key': 'udf3_value',
        'name': 'UDF3 Value',
      },
      {
        'key': 'udf4_name',
        'name': 'UDF4 Name',
      },
      {
        'key': 'udf4_value',
        'name': 'UDF4 Value',
      },
      {
        'key': 'one_time_concession',
        'name': 'One Time Concession',
      },
      {
        'key': 'recurring_concession',
        'name': 'Recurring Concession',
      },
      {
        'key': 'bike_storage',
        'name': 'Bike Storage',
      },
      {
        'key': 'premium_view_fee',
        'name': 'Premium View Fee',
      },
      {
        'key': 'premium_location_fee',
        'name': 'Premium Location Fee',
      },
      {
        'key': 'upgraded_unit_fee',
        'name': 'Upgraded Unit Fee',
      },
      {
        'key': 'amenity_access_fee',
        'name': 'Amenity Access Fee',
      },
    ];
  }

  static getCurrencyFields() {
    return [
      'required_deposit',
      'garage_deposit',
      'key_deposit',
      'misc_deposit',
      'pet_deposit',
      'security_deposit',
      'storage_deposit',
      'deposit_on_hand',
      'balance',
      'lease_rent',
      'market_rent',
      'rent',
      'renters_insurance',
      'rent_concession',
      'other_rent_discount',
      'pet_rent',
      'preferred_employer_discount',
      'fee_6_month',
      'admin_fee',
      'boat_slip_fee',
      'cable_fee',
      'carport_fee',
      'corporate_rent',
      'double_occupancy',
      'electric_fee',
      'furniture_fee',
      'garage_fee',
      'gas_fee',
      'guest_suite_fee',
      'hud_fee',
      'internet_fee',
      'misc_fee',
      'lease_break_fee',
      'lock_key',
      'month_to_month_fee',
      'parking_fee',
      'pest_fee',
      'recycling_fee',
      'rubs_fee',
      'scep_fee',
      'short_term_fee',
      'sewer_fee',
      'storage_fee',
      'telecom_fee',
      'transfer_fee',
      'trash_fee',
      'utility_fee',
      'valet_waste_fee',
      'washer_dryer_fee',
      'water_fee',
      'total_amenity_fee',
      'admin_concession',
      'cable_concession',
      'electric_concession',
      'employee_discount',
      'furniture_concession',
      'garage_concession',
      'gift_card_concession',
      'guest_suite_concession',
      'housing_concession',
      'gift_card',
      'internet_concession',
      'misc_concession',
      'office_model_concession',
      'parking_concession',
      'pest_concession',
      'pet_concession',
      'preferred_employer',
      'referral_concession',
      'renewal_concession',
      'storage_concession',
      'trash_concession',
      'washer_dryer_concession',
      'water_concession',
      'total_billing',
      'parcel_locker',
      'pet_fee',
      'udf1_value',
      'udf2_value',
      'udf3_value',
      'udf4_value',
      'one_time_concession',
      'recurring_concession',
      'bike_storage',
      'premium_view_fee',
      'premium_location_fee',
      'upgraded_unit_fee',
      'amenity_access_fee',
    ];
  }

  static getDateFields() {
    return [
      'move_in_date',
      'move_out_date',
      'lease_start_date',
      'lease_end_date'
    ];
  }
}

export default UnitOptions;